import React, { useEffect, useRef } from "react";
import { CallsVolumeChartModel } from "../../models/AdminDashboardModel";

type Props = {
    model?: CallsVolumeChartModel
}

function CallsVolumeChart(props: Props) {

    const ref = useRef<HTMLDivElement>(null);
    const chartRef = useRef<any>(null);

    useEffect(() => {
        if (!props.model || !ref.current) return;
        const Apex = (window as any).ApexCharts;
        const KTUtil = (window as any).KTUtil;
        if (!Apex || !KTUtil) return;

        const labelColor = KTUtil.getCssVariableValue("--bs-gray-500");
        const borderColor = KTUtil.getCssVariableValue("--bs-gray-200");
        const successColor = KTUtil.getCssVariableValue("--bs-success");
        const primaryColor = KTUtil.getCssVariableValue("--bs-primary");
        const dangerColor = KTUtil.getCssVariableValue("--bs-danger");

        const options = {
            series: [
                { name: "Inbound", data: props.model.inbound },
                { name: "Outbound", data: props.model.outbound },
                { name: "Missed", data: props.model.missed },
            ],
            chart: {
                fontFamily: "inherit",
                type: "bar",
                height: 280,
                stacked: false,
                toolbar: { show: false }
            },
            plotOptions: {
                bar: { columnWidth: "50%", borderRadius: 4 }
            },
            legend: { show: true, position: "top", horizontalAlign: "left", fontSize: "12px" },
            dataLabels: { enabled: false },
            stroke: { show: true, width: 2, colors: ["transparent"] },
            xaxis: {
                categories: props.model.labels,
                axisBorder: { show: false },
                axisTicks: { show: false },
                labels: { style: { colors: labelColor, fontSize: "11px" } }
            },
            yaxis: {
                labels: { style: { colors: labelColor, fontSize: "12px" } }
            },
            fill: { opacity: 1 },
            colors: [successColor, primaryColor, dangerColor],
            grid: { borderColor: borderColor, strokeDashArray: 4 },
            tooltip: { style: { fontSize: "12px" } }
        };

        if (chartRef.current) {
            try { chartRef.current.destroy(); } catch { }
        }
        chartRef.current = new Apex(ref.current, options);
        chartRef.current.render();

        return () => {
            if (chartRef.current) {
                try { chartRef.current.destroy(); } catch { }
                chartRef.current = null;
            }
        };
    }, [props.model]);

    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header border-0 pt-5">
                <div>
                    <h3 className="widget-title">Calls Volume</h3>
                    <div className="widget-subtitle">Last 7 days</div>
                </div>
            </div>
            <div className="card-body pt-3">
                <div ref={ref} style={{ minHeight: 280 }} />
            </div>
        </div>
    );
}

export default CallsVolumeChart;
